export default __webpack_public_path__ + "static/media/cb17ce9564a663e28094810bbdc13d5b.svg";